"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoyaltyRedemption = /** @class */ (function () {
    function LoyaltyRedemption(json) {
        this.name = json.name;
        this.expiresAt = new Date(json.expiresAt);
        this.redeemedAt = json.redeemedAt ? new Date(json.redeemedAt) : null;
        this.count = json.count;
        this.targetCount = json.targetCount;
    }
    return LoyaltyRedemption;
}());
exports.default = LoyaltyRedemption;
